import React from "react";
import { chosenTheme } from "../../theme";

export default function WIDNumerical() {
  const theme = chosenTheme;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="933.32126"
      height="629.28662"
      viewBox="0 0 933.32126 629.28662"
      role="img"
      artist="Katerina Limpitsouni"
      source="https://undraw.co/"
    >
      <title>digital currency</title>
      <circle cx="603.48189" cy="110.6591" r="32" fill="#f2f2f2" />
      <rect
        x="175.66063"
        y="277.72485"
        width="642"
        height="343"
        transform="translate(174.10872 -328.57838) rotate(31.45906)"
        fill="#f2f2f2"
      />
      <path
        d="M811.32126,563.26576c-5-11.5-12.7-21.6-28.1-30.1a98.14691,98.14691,0,0,0-25.4-10,62.21919,62.21919,0,0,0,16.3-11,56.36778,56.36778,0,0,0,15.6-23.3,77.109,77.109,0,0,0,3.5-28.2c-1.1-16.8-4.4-33.1-13.2-44.8s-21.2-20.7-37.6-27c-12.6-4.8-25.5-7.8-45.5-8.9v-63.9l-40,25v39h-32v-41l-41-23v64h-87.1l28,48c8.65.01,14.51.81,17.5,2.3a13.22451,13.22451,0,0,1,6.5,6c1.3,2.5,1.9,8.4,1.9,17.5v173.2c0,9-.6,14.8-1.9,17.4s-2,4.9-5.1,6.30005-3.2,1.3-11.8,1.3h-.1l-35,48h87v64h41v-64h32v64h40v-64.4c26-1.3,44.5-4.7,59.4-10.3,19.3-7.2,34.1-17.7,44.7-31.5s14.9-34.9,15.8-51.2C817.42124,592.16573,815.82126,573.46571,811.32126,563.26576Zm-186.5-129.2h.01v-1.33h27.96c15.73005,0,68.15-5.24,69.02,37.57.88,42.81-69.02,41.06-69.02,41.06h-27.96v-3.3h-.01Zm0,122h32c6.5,0,28.86.99,37,1.36a35.49854,35.49854,0,0,1,9.76,1.74c1.15.39,2.24.83,3.42,1.32a49.73214,49.73214,0,0,1,13.79,6.98,28.80655,28.80655,0,0,1,7.13,6.7,38.22857,38.22857,0,0,1,2.36,3.69,37.47292,37.47292,0,0,1,4.17,10.29,41.737,41.737,0,0,1,1.47,10.72c0,7.79-1.44,14.24-4.99,19.7-4.81,8.06-12.7,13.77-21.58,17.8-22.96,10.44-52.53,9.7-52.53,9.7h-32Z"
        transform="translate(-133.33937 -135.40665)"
        fill={theme.text}
      />
      <path
        d="M745.48083,247.41218a3.43718,3.43718,0,0,0-1.57527-1.74688,5.39315,5.39315,0,0,0-1.42391-.58035,3.48217,3.48217,0,0,0,.91377-.6384,3.28185,3.28185,0,0,0,.87453-1.35223,4.62294,4.62294,0,0,0,.19621-1.63661,4.9921,4.9921,0,0,0-.74-2.6,4.6334,4.6334,0,0,0-2.10784-1.567,7.68187,7.68187,0,0,0-2.5507-.51652v-3.70848l-2.24238,1.45089V236.78h-1.7939v-2.37947l-2.29844-1.33482V236.78h-4.88278l1.56967,2.78571a2.44727,2.44727,0,0,1,.981.13348.75246.75246,0,0,1,.36438.34822,2.88367,2.88367,0,0,1,.10652,1.01562v10.05179a2.888,2.888,0,0,1-.10652,1.00982c-.07287.15089-.11212.28437-.2859.36563s-.17939.07544-.6615.07544h-.00561l-1.96208,2.78572h4.87717v3.71428h2.29844v-3.71428h1.7939v3.71428H739.062v-3.7375a10.62847,10.62847,0,0,0,3.32994-.59777,5.47645,5.47645,0,0,0,2.50585-1.82812,5.80186,5.80186,0,0,0,.88574-2.97143A6.75424,6.75424,0,0,0,745.48083,247.41218ZM735.02574,239.914h.00056v-.07719h1.56742c.88182,0,3.82046-.30411,3.86923,2.1804.04933,2.48451-3.86923,2.38295-3.86923,2.38295H735.0263v-.19152h-.00056Zm0,7.08035h1.7939c.36439,0,1.61788.05746,2.0742.07893a1.92939,1.92939,0,0,1,.54715.101c.06446.02264.12557.04817.19172.07661a2.75323,2.75323,0,0,1,.77306.40509,1.63938,1.63938,0,0,1,.3997.38884,2.482,2.482,0,0,1,.36607.81134,2.502,2.502,0,0,1,.08241.62214,2.085,2.085,0,0,1-.27974,1.14331,2.64842,2.64842,0,0,1-1.20976,1.033,7.5542,7.5542,0,0,1-2.94481.563h-1.7939Z"
        transform="translate(-133.33937 -135.40665)"
        fill={chosenTheme.imageHighlight}
        opacity="0.3"
      />
      <circle cx="798.13048" cy="464.06323" r="11.72934" fill="#ff6584" />
      <line
        x1="890.59609"
        y1="591.74395"
        x2="890.59609"
        y2="458.19436"
        fill={theme.text}
        stroke={theme.text}
        stroke-miterlimit="10"
        stroke-width="2"
      />
      <circle cx="890.59609" cy="458.19436" r="18.8858" fill={theme.text} />
      <path
        d="M986.74065,668.37637c-27.27962,41.83458-19.805,95.04278-19.805,95.04278s51.70364-14.619,78.98326-56.45362,19.805-95.04278,19.805-95.04278S1014.02027,626.5418,986.74065,668.37637Z"
        transform="translate(-133.33937 -135.40665)"
        fill={theme.text}
      />
      <path
        d="M966.79054,762.93263s-.6641-.10594-1.88635-.35324c-.97495-.19779-2.31724-.4804-3.95629-.869-14.65246-3.45472-53.608-15.13287-79.07671-45.83666-31.87654-38.44683-30.53425-92.16081-30.53425-92.16081s48.74035,7.9197,80.85707,42.44555q2.08768,2.2254,4.06228,4.61332c27.73656,33.452,30.32227,78.46212,30.52718,89.58924C966.81171,762.02836,966.79054,762.93263,966.79054,762.93263Z"
        transform="translate(-133.33937 -135.40665)"
        fill={chosenTheme.imageHighlight}
      />
      <path
        d="M947.13068,668.37637c27.27962,41.83458,19.805,95.04278,19.805,95.04278s-51.70365-14.619-78.98327-56.45362-19.805-95.04278-19.805-95.04278S919.85106,626.5418,947.13068,668.37637Z"
        transform="translate(-133.33937 -135.40665)"
        fill="none"
        stroke={theme.text}
        stroke-miterlimit="10"
        stroke-width="2"
      />
      <path
        d="M966.78347,760.36107c-.72063.869-1.35644,1.61076-1.87928,2.21832-1.1586,1.32112-1.81566,2.01351-1.81566,2.01351s-.79829-1.00324-2.14063-2.88247c-7.36862-10.27226-31.07113-46.79747-29.24137-88.9887q.14838-3.31695.48748-6.56322,2.08768,2.2254,4.06228,4.61332C963.99285,704.22386,966.57856,749.234,966.78347,760.36107Z"
        transform="translate(-133.33937 -135.40665)"
        opacity="0.1"
      />
      <path
        d="M1007.232,675.77285c-2.15624,49.89649-39.19548,88.8205-39.19548,88.8205s-33.54326-41.97419-31.387-91.87068,39.19548-88.8205,39.19548-88.8205S1009.38828,625.87636,1007.232,675.77285Z"
        transform="translate(-133.33937 -135.40665)"
        fill={chosenTheme.imageHighlight}
      />
      <line
        x1="834.69719"
        y1="627.77373"
        x2="842.84032"
        y2="450.53065"
        fill="none"
        stroke={theme.text}
        stroke-miterlimit="10"
        stroke-width="2"
      />
      <line
        x1="57.47171"
        y1="627.96785"
        x2="903.49207"
        y2="627.96785"
        fill="none"
        stroke={theme.text}
        stroke-miterlimit="10"
        stroke-width="2"
      />
      <circle
        cx="237.15556"
        cy="369.08439"
        r="42.72978"
        fill={chosenTheme.imageHighlight}
      />
      <circle
        cx="164.52594"
        cy="469.64849"
        r="42.72978"
        fill={chosenTheme.imageHighlight}
      />
      <circle
        cx="75.13563"
        cy="549.9601"
        r="42.72978"
        fill={chosenTheme.imageHighlight}
      />
      <line
        x1="75.09765"
        y1="627.23521"
        x2="75.09765"
        y2="549.72504"
        fill={theme.text}
        stroke={theme.text}
        stroke-miterlimit="10"
        stroke-width="2"
      />
      <circle cx="75.09765" cy="549.72504" r="10.96103" fill={theme.text} />
      <path
        d="M208.437,732.90281s-1.56586-33.67836-33.666-29.7637"
        transform="translate(-133.33937 -135.40665)"
        fill={theme.text}
      />
      <line
        x1="237.18237"
        y1="627.77896"
        x2="237.18237"
        y2="369.24136"
        fill={theme.text}
        stroke={theme.text}
        stroke-miterlimit="10"
        stroke-width="2"
      />
      <circle cx="237.18237" cy="369.11888" r="10.96103" fill={theme.text} />
      <circle cx="203.51633" cy="556.17215" r="10.96103" fill={theme.text} />
      <path
        d="M370.52174,560.515s-1.56586-33.67836-33.666-29.76371"
        transform="translate(-133.33937 -135.40665)"
        fill={theme.text}
      />
      <path
        d="M370.52174,655.98938s-1.56586-33.67836-33.666-29.76371"
        transform="translate(-133.33937 -135.40665)"
        fill={theme.text}
      />
      <path
        d="M370.52174,760.17264s7.04638-65.46212-33.666-68.59384"
        transform="translate(-133.33937 -135.40665)"
        fill="none"
        stroke={theme.text}
        stroke-miterlimit="10"
        stroke-width="2"
      />
      <circle cx="270.85321" cy="556.17215" r="10.96103" fill={theme.text} />
      <path
        d="M370.52654,760.17264s-7.04638-65.46212,33.666-68.59384"
        transform="translate(-133.33937 -135.40665)"
        fill="none"
        stroke={theme.text}
        stroke-miterlimit="10"
        stroke-width="2"
      />
      <circle cx="271.52086" cy="453.35361" r="10.96103" fill={theme.text} />
      <path
        d="M371.19419,653.86229s-7.04638-61.97031,33.666-65.102"
        transform="translate(-133.33937 -135.40665)"
        fill="none"
        stroke={theme.text}
        stroke-miterlimit="10"
        stroke-width="2"
      />
      <line
        x1="164.56493"
        y1="627.41442"
        x2="164.56493"
        y2="469.60063"
        fill={theme.text}
        stroke={theme.text}
        stroke-miterlimit="10"
        stroke-width="2"
      />
      <circle cx="164.56493" cy="469.60063" r="10.96103" fill={theme.text} />
      <path
        d="M297.9043,649.64668s-1.56587-33.67837-33.666-29.76371"
        transform="translate(-133.33937 -135.40665)"
        fill={theme.text}
      />
      <path
        d="M297.9043,759.80811s7.04638-64.76376-33.666-67.89548"
        transform="translate(-133.33937 -135.40665)"
        fill="none"
        stroke={theme.text}
        stroke-miterlimit="10"
        stroke-width="2"
      />
      <circle cx="130.89889" cy="556.50598" r="10.96103" fill={theme.text} />
      <circle cx="766.48189" cy="369.6591" r="18" fill="#f2f2f2" />
      <path
        d="M709.35129,636.36574c-22.96,10.44-52.53,9.7-52.53,9.7h-32v-6.11c13.04-3.64,31.07-5.89,51-5.89A233.65913,233.65913,0,0,1,709.35129,636.36574Z"
        transform="translate(-133.33937 -135.40665)"
        opacity="0.1"
      />
      <path
        d="M747.82126,654.06575c0,11.05-32.24,20-72,20s-72-8.95-72-20c0-5.51,8.02-10.5,21-14.11v6.11h32s29.57.74,52.53-9.7C732.22129,639.70577,747.82126,646.37575,747.82126,654.06575Z"
        transform="translate(-133.33937 -135.40665)"
        opacity="0.1"
      />
      <rect
        x="521.04322"
        y="394.12881"
        width="30.63497"
        height="30.68959"
        fill="#2f2e41"
      />
      <path
        d="M665.77484,551.23835s2.53573,8.875-1.9018,9.509a17.32288,17.32288,0,0,0-7.60719,3.16967l8.24112,10.77684h15.21438l9.509-9.509s-12.67865-9.509-10.14292-15.21437S665.77484,551.23835,665.77484,551.23835Z"
        transform="translate(-133.33937 -135.40665)"
        fill="#ffb9b9"
      />
      <path
        d="M665.77484,551.23835s2.53573,8.875-1.9018,9.509a17.32288,17.32288,0,0,0-7.60719,3.16967l8.24112,10.77684h15.21438l9.509-9.509s-12.67865-9.509-10.14292-15.21437S665.77484,551.23835,665.77484,551.23835Z"
        transform="translate(-133.33937 -135.40665)"
        opacity="0.1"
      />
      <polygon
        points="536.239 526.136 550.82 531.207 560.962 531.841 560.328 522.966 539.409 516.779 536.239 526.136"
        fill="#ffb9b9"
      />
      <path
        d="M688.27943,659.64076s0,8.875,1.26786,8.875,18.384-1.9018,23.4555,0,12.67864-5.07146,8.875-8.875-10.00785-9.509-13.879-8.24112-19.71943,4.43752-19.71943,4.43752Z"
        transform="translate(-133.33937 -135.40665)"
        fill="#2f2e41"
      />
      <path
        d="M641.68541,651.39964s-7.60718,15.21437-2.53573,16.48224,10.77685-.63394,11.41078-1.26787,9.509-3.16966,10.77685-1.90179,1.26787-5.07146,1.26787-5.07146Z"
        transform="translate(-133.33937 -135.40665)"
        fill="#2f2e41"
      />
      <path
        d="M648.02474,630.47988s-12.04472,16.48223-3.16967,20.91976,51.34851,4.43752,54.51817,0,4.43753-18.384,0-19.6519S648.02474,630.47988,648.02474,630.47988Z"
        transform="translate(-133.33937 -135.40665)"
        fill="#2f2e41"
      />
      <path
        d="M648.02474,630.47988s-12.04472,16.48223-3.16967,20.91976,51.34851,4.43752,54.51817,0,4.43753-18.384,0-19.6519S648.02474,630.47988,648.02474,630.47988Z"
        transform="translate(-133.33937 -135.40665)"
        opacity="0.2"
      />
      <circle cx="537.50693" cy="405.68879" r="14.58044" fill="#ffb9b9" />
      <path
        d="M648.02474,563.917l12.67864-2.53573s3.16966,10.14291,13.31258,8.24112,12.67864-8.24112,12.67864-8.24112,7.60719,3.16966,8.24112,3.16966,8.87505,3.16966,8.87505,5.07146-9.509,20.91976-9.509,20.91976l1.26786,34.23234-46.911-1.26787,3.16966-33.5984Z"
        transform="translate(-133.33937 -135.40665)"
        fill={chosenTheme.imageHighlight}
      />
      <path
        d="M641.05148,580.39923s-3.80359,33.59841-1.26786,36.13414,12.67864,9.509,12.67864,9.509v-7.60719l-5.07146-9.509,5.07146-22.18763Z"
        transform="translate(-133.33937 -135.40665)"
        fill="#ffb9b9"
      />
      <path
        d="M706.66346,579.44833s-2.21876,34.54931-2.21876,35.81717-5.70539,5.70539-7.60719,5.70539-3.16966-3.16966-3.16966-3.16966l4.43753-5.07146-3.16966-25.99122Z"
        transform="translate(-133.33937 -135.40665)"
        fill="#ffb9b9"
      />
      <path
        d="M700.64111,627.94415s28.52695-15.84831,29.16088,0-14.58044,22.18762-14.58044,22.18762-39.3038,11.78567-40.88863,7.47767-4.75449-11.28126-2.21876-11.91519,5.70539-1.9018,6.97325-.63393,17.11617-9.509,17.11617-9.509Z"
        transform="translate(-133.33937 -135.40665)"
        fill="#2f2e41"
      />
      <path
        d="M713.95368,626.04235s-5.70539,2.53573-7.60718,4.43753-10.14292,5.07145-10.14292,5.07145"
        transform="translate(-133.33937 -135.40665)"
        fill="none"
        stroke="#000"
        stroke-miterlimit="10"
        stroke-width="2"
        opacity="0.2"
      />
      <path
        d="M651.82833,565.18486l-3.80359-1.26786s-13.94651,14.58044-9.509,18.384,6.97326,5.07146,8.24112,6.33932,7.60719,1.9018,7.60719,1.9018Z"
        transform="translate(-133.33937 -135.40665)"
        fill={chosenTheme.imageHighlight}
      />
      <path
        d="M698.10538,568.35452l5.70539,1.26787s4.43752,9.509,5.70539,10.77684-1.9018.63393-3.80359,3.16966-3.8036,6.97326-7.60719,6.97326-8.875-6.33932-8.875-6.33932Z"
        transform="translate(-133.33937 -135.40665)"
        fill={chosenTheme.imageHighlight}
      />
      <path
        d="M649.2926,633.64954s-24.08942-17.11617-32.33054-4.43753,35.5002,29.79482,41.83952,32.33054,12.04471,5.07146,12.04471,5.07146,5.70539-13.94651,5.70539-16.48224-4.43752-2.53572-5.70539-2.53572-6.97325-1.26787-8.24111-3.16967S649.2926,633.64954,649.2926,633.64954Z"
        transform="translate(-133.33937 -135.40665)"
        fill="#2f2e41"
      />
      <path
        d="M635.98,629.212s6.33933,5.07146,12.04472,6.33932,7.60718,4.43753,7.60718,4.43753"
        transform="translate(-133.33937 -135.40665)"
        fill="none"
        stroke="#000"
        stroke-miterlimit="10"
        stroke-width="2"
        opacity="0.2"
      />
      <path
        d="M644.91967,605.37641l.50643,26.841a3.36009,3.36009,0,0,0,3.39725,3.2965l49.94949-.56123a3.36009,3.36009,0,0,0,3.31677-3.16636l1.51614-26.27972a3.36009,3.36009,0,0,0-3.35452-3.55363H648.27917A3.36009,3.36009,0,0,0,644.91967,605.37641Z"
        transform="translate(-133.33937 -135.40665)"
        fill="#575a89"
      />
      <path
        d="M639.14191,564.07673c1.36044-3.002,3.18865-5.81924,4.05984-8.99785,1.0442-3.80983.63756-7.84085.51333-11.78926a37.01665,37.01665,0,0,1,.88372-10.403,17.88521,17.88521,0,0,1,5.14221-8.95254c6.64339-5.93056,18.80176-6.35642,26.91381-3.88756,3.198.9733,6.60472,2.82677,7.39769,6.07421.11971.49027.1734.99547.30707,1.4821.66415,2.41785,3.13766,3.94774,4.03012,6.29093,1.15431,3.03076-.62556,6.32663-.85822,9.5614-.27162,3.77656,1.58487,7.34437,3.41475,10.65914,1.08781,1.97055,2.21886,4.06967,2.11089,6.31792a7.982,7.982,0,0,1-1.09228,3.48262,13.28062,13.28062,0,0,1-11.15615,6.395,6.99921,6.99921,0,0,1-4.17879-.98656c-1.97972-1.36319-2.55955-4.10818-2.14713-6.47618s1.61445-4.50975,2.55626-6.72117c.289-.6786.54984-1.36873.79026-2.06578a14.18553,14.18553,0,1,0-9.35726,1.58721,19.21586,19.21586,0,0,1-.93055,10.68479,40.34676,40.34676,0,0,1-4.48666,7.823,10.80067,10.80067,0,0,1-2.85833,3.19882,10.14284,10.14284,0,0,1-2.435,1.03991c-3.58068,1.15158-7.35129,2.07819-11.07674,1.56014s-7.415-2.765-8.68447-6.30565C636.888,570.54595,637.78147,567.0787,639.14191,564.07673Z"
        transform="translate(-133.33937 -135.40665)"
        fill="#2f2e41"
      />
      <ellipse
        cx="536.80054"
        cy="397.50197"
        rx="15.47356"
        ry="8.76835"
        fill="#2f2e41"
      />
      <path
        d="M906.55029,506.112a2.67089,2.67089,0,0,0-1.22408-1.35743,4.191,4.191,0,0,0-1.10647-.451,2.70561,2.70561,0,0,0,.71005-.49607,2.55016,2.55016,0,0,0,.67957-1.05077,3.592,3.592,0,0,0,.15246-1.27174,3.87917,3.87917,0,0,0-.575-2.02036,3.60041,3.60041,0,0,0-1.63792-1.21763,5.96938,5.96938,0,0,0-1.98206-.40137v-2.88172l-1.74247,1.12743v1.7588h-1.394v-1.849l-1.786-1.03724v2.88623h-3.79423l1.21973,2.16467a1.90167,1.90167,0,0,1,.76233.10373.58465.58465,0,0,1,.28315.27058,2.24093,2.24093,0,0,1,.08277.78921v7.81086a2.24426,2.24426,0,0,1-.08277.7847c-.05663.11725-.08712.221-.22216.28411s-.1394.05863-.514.05863h-.00436l-1.52466,2.16467H896.64v2.88624h1.786v-2.88624h1.394v2.88624h1.74246v-2.90428a8.25855,8.25855,0,0,0,2.58757-.4645,4.25556,4.25556,0,0,0,1.94721-1.42057,4.5084,4.5084,0,0,0,.68827-2.309A5.24829,5.24829,0,0,0,906.55029,506.112Zm-8.12426-5.82658h.00044v-.06h1.218c.68523,0,2.96873-.23631,3.00663,1.69431.03834,1.93062-3.00663,1.8517-3.00663,1.8517h-1.218v-.14882H898.426Zm0,5.50188h1.394c.28315,0,1.25719.04465,1.61178.06133a1.49943,1.49943,0,0,1,.42516.07847c.0501.01759.09758.03743.149.05953a2.13908,2.13908,0,0,1,.60072.31478,1.274,1.274,0,0,1,.31059.30215,1.92848,1.92848,0,0,1,.28446.63046,1.94458,1.94458,0,0,1,.064.48345,1.62015,1.62015,0,0,1-.21738.88842,2.05788,2.05788,0,0,1-.94006.80273,5.86982,5.86982,0,0,1-2.28829.43744h-1.394Z"
        transform="translate(-133.33937 -135.40665)"
        fill={chosenTheme.imageHighlight}
        opacity="0.3"
      />
      <circle cx="64.48189" cy="432.6591" r="18" fill="#f2f2f2" />
      <path
        d="M204.55029,569.112a2.67089,2.67089,0,0,0-1.22408-1.35743,4.191,4.191,0,0,0-1.10647-.451,2.70561,2.70561,0,0,0,.71-.49607,2.55016,2.55016,0,0,0,.67957-1.05077,3.592,3.592,0,0,0,.15246-1.27174,3.87917,3.87917,0,0,0-.575-2.02036,3.60041,3.60041,0,0,0-1.63792-1.21763,5.96938,5.96938,0,0,0-1.98206-.40137v-2.88172l-1.74247,1.12743v1.7588h-1.394v-1.849l-1.786-1.03724v2.88623h-3.79423l1.21973,2.16467a1.90167,1.90167,0,0,1,.76233.10373.58465.58465,0,0,1,.28315.27058,2.24093,2.24093,0,0,1,.08277.78921v7.81086a2.24426,2.24426,0,0,1-.08277.7847c-.05663.11725-.08712.221-.22216.28411s-.1394.05863-.514.05863h-.00436l-1.52466,2.16467H194.64v2.88624h1.786v-2.88624h1.394v2.88624h1.74246v-2.90428a8.25855,8.25855,0,0,0,2.58757-.4645,4.25556,4.25556,0,0,0,1.94721-1.42057,4.5084,4.5084,0,0,0,.68827-2.309A5.24829,5.24829,0,0,0,204.55029,569.112Zm-8.12426-5.82658h.00044v-.06h1.218c.68523,0,2.96873-.23631,3.00663,1.69431.03834,1.93062-3.00663,1.8517-3.00663,1.8517h-1.218v-.14882H196.426Zm0,5.50188h1.394c.28315,0,1.25719.04465,1.61178.06133a1.49943,1.49943,0,0,1,.42516.07847c.0501.01759.09758.03743.149.05953a2.13908,2.13908,0,0,1,.60072.31478,1.274,1.274,0,0,1,.31059.30215,1.92848,1.92848,0,0,1,.28446.63046,1.94458,1.94458,0,0,1,.064.48345,1.62015,1.62015,0,0,1-.21738.88842,2.05788,2.05788,0,0,1-.94006.80273,5.86982,5.86982,0,0,1-2.28829.43744h-1.394Z"
        transform="translate(-133.33937 -135.40665)"
        fill={chosenTheme.imageHighlight}
        opacity="0.3"
      />
    </svg>
  );
}
